const defaultState = {
  count: 0,
  data: [],
  isLoading: true
};

export const initialStore = {
  agentsPage: defaultState,
  banksPage: defaultState,
  blackListPage: defaultState,
  cardsPage: defaultState,
  clientsPage: defaultState,
  correctionsPage: defaultState,
  cryptoWalletsPage: defaultState,
  debtorsPage: defaultState,
  devicesPage: defaultState,
  greyListPage: defaultState,
  holdersPage: defaultState,
  incomesPage: { ...defaultState, countNew: 0 },
  notificationsPage: defaultState,
  operatorsPage: defaultState,
  outcomesPage: {
    ...defaultState,
    countNew: 0
  },
  providersPage: defaultState,
  requestLogsPage: defaultState,
  stats: {
    data: {
      cardsInfo: {
        activeCardsBalance: 0,
        activeOperatorsCardsBalance: 0
      },
      income: {
        amount: 0,
        operations: 0
      },
      outcome: {
        amount: 0,
        operations: 0
      }
    }
  },
  tariffsPage: defaultState,
  tradersPage: defaultState,
  transactionsPage: defaultState,
  userData: {
    countIncomes: 0,
    countOutcomes: 0,
    isLoading: true,
    user: null
  },
  usersPage: defaultState
};
